import { useRef, useState } from 'react';
import useOutsideClick from '../../../../../hook/useOutsideClick';
import ManageTaskModal from '../manage-task-modal';
import './styles.scss';
import { deleteCNADefaultTaskService } from '../../../../../services/cna/default-tasks';
import { isResponseOk } from '../../../../../utility/isResponseOk';

const TaskItem = ({ task, companyID, onRefetchTasks }) => {
  const dropdownRef = useRef();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isEditTaskModalOpen, setIsEditTaskModalOpen] = useState(false);

  const handleDeleteTask = async (taskID) => {
    try {
      const res = await deleteCNADefaultTaskService({ taskID });
      if (isResponseOk(res)) {
        await onRefetchTasks();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useOutsideClick(dropdownRef, closeDropdown);

  return (
    <>
      <div className={'tasks__list__item'}>
        <p>{task.text}</p>
        <div className="dropdown default-task-dropdown" ref={dropdownRef}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsDropdownOpen(!isDropdownOpen);
            }}
            className="btn btn-outline task-dropdown-btn"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                fill="#667085"
              />
              <path
                d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                fill="#667085"
              />
              <path
                d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                fill="#667085"
              />
              <path
                d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
                stroke="#667085"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
                stroke="#667085"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
                stroke="#667085"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {isDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <button
                  className="btn btn-left btn-full btn-text"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsEditTaskModalOpen(true);
                  }}
                >
                  <i className="icon-icon-edit mr-2"></i>Edit
                </button>
              </li>
              <li>
                <button
                  className="btn btn-left btn-full btn-danger btn-text"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteTask(task.id);
                  }}
                >
                  <i className="icon-remove mr-2"></i>Delete
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
      {isEditTaskModalOpen && (
        <ManageTaskModal
          editTaskData={task}
          companyID={companyID}
          onRefetchTasks={onRefetchTasks}
          onClose={() => setIsEditTaskModalOpen(false)}
        />
      )}
    </>
  );
};

export default TaskItem;
